import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedButtonComponent } from '@plugins/client/button/shared-button';
import { ModalContentComponent } from '@plugins/client/dialog/modal/content/modal-content.component';
import { ModalFooterComponent } from '@plugins/client/dialog/modal/footer/modal-footer.component';
import { ModalHeaderComponent } from '@plugins/client/dialog/modal/header/modal-header.component';
import { TranslatePipe } from '@plugins/client/translate/pipes';

import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDialogTranslationModule } from './translation-loader';

@NgModule({
  imports: [
    CommonModule,
    ConfirmDialogTranslationModule,
    TranslatePipe,
    A11yModule,
    ModalHeaderComponent,
    ModalContentComponent,
    ModalFooterComponent,
    SharedButtonComponent,
  ],
  declarations: [ConfirmDialogComponent],
  providers: [],
})
export class ConfirmDialogModule {}
